var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 37.5C33.627 37.5 39 32.799 39 27C39 21.201 33.627 16.5 27 16.5C20.373 16.5 15 21.201 15 27C15 29.64 16.1145 32.055 17.955 33.9C17.8095 35.424 17.3295 37.095 16.7985 38.349C16.68 38.628 16.9095 38.94 17.208 38.892C20.592 38.337 22.6035 37.485 23.478 37.041C24.6269 37.3474 25.811 37.5017 27 37.5Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBg);
export default __webpack_public_path__ + "static/media/messageBG.58ced10c.svg";
export { ForwardRef as ReactComponent };